var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 4C26 5.0606 25.5872 6.0248 24.9136 6.7407L30.1614 13.3004C30.3086 13.4845 30.5644 13.5407 30.7754 13.4353L36.077 10.7845C36.0264 10.5308 36 10.2685 36 10C36 7.79086 37.7908 6 40 6C42.2092 6 44 7.79086 44 10C44 11.9038 42.67 13.4969 40.8886 13.901L37.2802 33.145C36.9698 34.8004 35.5244 36 33.8402 36H10.1599C8.47564 36 7.03024 34.8004 6.71984 33.145L3.1116 13.901C1.33002 13.497 0 11.9038 0 10C0 7.79086 1.79086 6 4 6C6.20914 6 8 7.79086 8 10C8 10.2685 7.97354 10.5308 7.9231 10.7845L13.2247 13.4353C13.4356 13.5407 13.6915 13.4845 13.8388 13.3004L19.0866 6.74074C18.4128 6.02484 18 5.06064 18 4C18 1.79086 19.7908 0 22 0C24.2092 0 26 1.79086 26 4ZM22 28C24.2092 28 26 26.2092 26 24C26 21.7908 24.2092 20 22 20C19.7908 20 18 21.7908 18 24C18 26.2092 19.7908 28 22 28Z",
    fill: "#FDB10E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/Crown.838de6e28e8ef7ca49278c6f8249b000.svg";
export { ForwardRef as ReactComponent };